import { useEffect, useState } from "react";
import {
  FormControl,
  // FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  // useTheme,
} from "@mui/material";
// import { Feature } from "flagged";
// import { SYNC } from "../../FeatureFlags";
// import { CustomSwitch, OutlinedDiv } from "../CustomSwitch";
import { Controller, useFormContext } from "react-hook-form";
import { useUploadQueue } from "../../store/uploadQueue/hooks";
import { RECORDING_DEVICE_TYPES, WAV } from "../../pages/app/utils/constants";

export const RecordingDeviceType = () => {
  // const theme = useTheme();
  const {
    control,
    formState: { errors },
    setValue,
    trigger,
    watch,
  } = useFormContext();
  const { fileData } = useUploadQueue();
  const { fileType } = fileData || {};
  const [editable, setEditable] = useState(true);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const numChannels = watch("numberOfChannels");
  const deviceType = watch("recordingDevice");

  const onRecordDeviceClick = (event) => {
    const selected = RECORDING_DEVICE_TYPES.find(
      (data) => data.id === event.target.value,
    );

    const fieldsToUpdate = {
      recordingDevice: selected.id,
      arrayWidth: selected.arrayWidth,
      sync: selected.sync,
    };

    Object.entries(fieldsToUpdate).forEach(([field, value]) => {
      setValue(field, value, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    });

    setEditable(selected.allowEdit);
    setSelectedDevice(selected);
  };

  useEffect(() => {
    if (!selectedDevice && Number(numChannels) === 1 && fileType === WAV) {
      setValue("arrayWidth", 0, { shouldValidate: true, shouldDirty: true });
    }
  }, [selectedDevice, deviceType, fileType, numChannels, setValue]);

  useEffect(() => {
    trigger("arrayWidth");
  }, [numChannels, trigger]);

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 5 }}>
        <Controller
          name="recordingDevice"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel id="recording-device-label">
                Type of Recording Device*
              </InputLabel>
              <Select
                {...field}
                value={RECORDING_DEVICE_TYPES.length > 0 ? field.value : ""}
                labelId="recording-device-label"
                label="Type of Recording Device"
                onChange={(e) => onRecordDeviceClick(e)}
              >
                {RECORDING_DEVICE_TYPES.map((data) => (
                  <MenuItem key={data.id} value={data.id}>
                    {data.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 3 }}>
        <Controller
          name="arrayWidth"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              disabled={!editable}
              fullWidth
              label="Array Width*"
              type="number"
              error={!!errors.arrayWidth}
              helperText={
                errors.arrayWidth
                  ? errors.arrayWidth.message
                  : "Please enter the array width."
              }
              slotProps={{
                htmlInput: {
                  min: 0,
                  step: 1,
                },
                input: {
                  endAdornment: (
                    <InputAdornment position="end">cm</InputAdornment>
                  ),
                },
              }}
            />
          )}
        />
      </Grid>
      {/* <Feature name={SYNC}>
        {numChannels > 1 && (
          <Grid size={{ xs: 12, md: 6, lg: 4 }}>
            <FormControl
              fullWidth
              sx={{
                " .MuiFormLabel-root": {
                  color: !editable
                    ? theme.palette.text.disabled
                    : theme.palette.text.secondary,
                },
                ":hover:not(:focus-within) fieldset.MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: !editable
                      ? theme.palette.action.disabled
                      : theme.palette.text.primary,
                  },
              }}
            >
              <OutlinedDiv label="Common Clock*">
                <Controller
                  name="sync"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <FormControlLabel
                      control={
                        <CustomSwitch
                          checked={value}
                          disabled={!editable}
                          onChange={(e) => onChange(e.target.checked)}
                          slotProps={{
                            input: { "aria-label": "common-clock" },
                          }}
                          sx={{ ml: 1 }}
                        />
                      }
                      label={value ? "On" : "Off"}
                      labelPlacement="start"
                      sx={{ marginLeft: 0 }}
                    />
                  )}
                />
              </OutlinedDiv>
            </FormControl>
          </Grid>
        )}
      </Feature> */}
    </Grid>
  );
};
